import React from 'react';
import { DownloadIcon } from 'lucide-react';
import Carousel from './Carousel';
const Hero = () => {
  return <section id="inicio" className="bg-gradient-to-b from-white to-blue-50 py-16 md:py-24" data-id="element-88">
      <div className="container mx-auto px-4" data-id="element-89">
        <div className="flex flex-col md:flex-row items-center" data-id="element-90">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10" data-id="element-91">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" data-id="element-92">
              El agua ya no es una necesidad,
              <br data-id="element-93" />
              <span className="text-[#2d98e2]" data-id="element-94">sino una constante</span>
            </h1>
            <p className="text-lg text-gray-600 mb-8" data-id="element-95">
              Estamos transformando nuestra sociedad mediante la democratización
              del acceso a los recursos hídricos, construyendo una comunidad
              consciente y conectada donde el agua es una fuerza transformadora.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-96">
              <button className="bg-[#2d98e2] hover:bg-[#146ead] text-white font-medium py-3 px-6 rounded-lg transition-colors flex items-center justify-center" data-id="element-97">
                <DownloadIcon size={20} className="mr-2" data-id="element-98" />
                Descarga la App
              </button>
              <button className="border-2 border-[#2d98e2] text-[#2d98e2] hover:bg-blue-50 font-medium py-3 px-6 rounded-lg transition-colors" data-id="element-99">
                Suscríbete ahora
              </button>
            </div>
          </div>
          <div className="md:w-1/2 w-full" data-id="element-100">
            <div className="bg-white p-4 rounded-xl shadow-lg aspect-[4/3] w-full" data-id="element-101">
              <Carousel data-id="element-102" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;